import { render, staticRenderFns } from "./ToolheadParkingSettings.vue?vue&type=template&id=2320a5fe&"
import script from "./ToolheadParkingSettings.vue?vue&type=script&lang=ts&"
export * from "./ToolheadParkingSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports